import { colorUseCases, css, getColorScaleValueByUseCase } from "@vitality-ds/system";
import { BORDER_WIDTH } from "../constants";
var borders = colorUseCases.borders;
export default css({
  borderBottom: "".concat(BORDER_WIDTH, "px solid"),
  borderBottomColor: getColorScaleValueByUseCase("neutralA", borders.subtle),
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start"
});